import { render, staticRenderFns } from "./nuevo.vue?vue&type=template&id=3b654705&scoped=true"
import script from "./nuevo.vue?vue&type=script&lang=js"
export * from "./nuevo.vue?vue&type=script&lang=js"
import style0 from "./nuevo.vue?vue&type=style&index=0&id=3b654705&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b654705",
  null
  
)

export default component.exports